<template>
  <v-timeline-item
    dot-color="userActivity"
    icon="mdi-account-sync-outline"
    fill-dot
  >
    <v-expansion-panels
      class="expansion-panels"
      variant="accordion"
      flat
    >
      <v-expansion-panel>
        <v-expansion-panel-title>
          <v-row
            no-gutters
            align="center"
            class="d-flex justify-center"
            :class="{ 'flex-column': $vuetify.display.smAndDown }"
          >
            <v-col md="8">
              <div class="mb-2 text-subtitle-1">
                {{ title }}
              </div>
              <div class="text-grey">
                {{ subtitle }}
              </div>
            </v-col>
            <v-col
              class="pr-2 text-right text-grey"
              :class="{ 'text-start mt-2': $vuetify.display.smAndDown }"
              md="4"
            >
              {{ formatDate(data.createdAt) }}
            </v-col>
          </v-row>
        </v-expansion-panel-title>

        <v-expansion-panel-text>
          <div>
            <v-row v-if="$vuetify.display.mdAndUp">
              <v-col
                cols="12"
                md="6"
              >
                {{ $t('lead-timeline.lead-update.body-texts.0') }}
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                {{ $t('lead-timeline.lead-update.body-texts.1') }}
              </v-col>
            </v-row>
            <v-row
              v-for="(update, index) in updates"
              :key="index"
            >
              <v-col
                cols="12"
                md="6"
              >
                <div class="text-grey text--darken-3 text-body-2 font-weight-bold">
                  {{ update.after }}
                </div>
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                <div class="text-red text--darken-3 text-body-2 text-decoration-line-through">
                  {{ update.before }}
                </div>
              </v-col>
            </v-row>
          </div>
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-timeline-item>
</template>

<script>
import crmMixin from '@/mixins/crm'
import currencyMixin from '@/mixins/currency'

export default {
  mixins: [currencyMixin, crmMixin],

  props: {
    data: { type: Object, default: null },
  },

  computed: {
    changes() {
      return this.data.details.changes
    },
    title() {
      return {
        CRM: this.$t('lead-timeline.lead-update.title-crm', {
          readableCrmName: this.readableCrmName,
        }),
        IMPORT: this.$t('lead-timeline.lead-update.title-import'),
        CONVERSION: this.$t('lead-timeline.lead-update.title-conversion'),
        USER: this.$t('lead-timeline.lead-update.title-user'),
      }[this.changes?.origin]
    },
    subtitle() {
      return {
        CRM: this.$t('lead-timeline.lead-update.subtitle-crm', {
          readableCrmName: this.readableCrmName,
        }),
        IMPORT: this.$t('lead-timeline.lead-update.subtitle-import'),
        CONVERSION: this.$t('lead-timeline.lead-update.subtitle-conversion'),
        USER: this.$t('lead-timeline.lead-update.subtitle-user'),
      }[this.changes?.origin]
    },

    updates() {
      const before = this.changes?.before || {}
      const after = this.changes?.after || {}
      if (!before && !after) return []

      const changes = []
      const keys = new Set([...Object.keys(after), ...Object.keys(before)])
      Array.from(keys).forEach((key) => {
        if (before[key] || after[key]) {
          if (key === 'isDataProcessingPermissionGranted') {
            changes.push({
              before:
                `${this.$t('labels.gdpr')} ` +
                (before[key] ? this.$t('labels.accepted') : this.$t('labels.not-accepted')),
              after:
                `${this.$t('labels.gdpr')} ` +
                (after[key] ? this.$t('labels.accepted') : this.$t('labels.not-accepted')),
            })
          } else if (key === 'communicationNotAccepted') {
            changes.push({
              before: this.$t(
                before[key] ? 'labels.communication-not-accepted' : 'labels.communication-accepted'
              ),
              after: this.$t(
                after[key] ? 'labels.communication-not-accepted' : 'labels.communication-accepted'
              ),
            })
          } else if (key === 'phoneCommunicationAccepted') {
            changes.push({
              before: this.$t(
                before[key]
                  ? 'leads.table.labels.phone-communication-accepted'
                  : 'leads.table.labels.phone-communication-not-accepted'
              ),
              after: this.$t(
                after[key]
                  ? 'leads.table.labels.phone-communication-accepted'
                  : 'leads.table.labels.phone-communication-not-accepted'
              ),
            })
          } else if (key !== '__typename') {
            changes.push({ before: before[key], after: after[key] })
          }
        }
      })
      return changes
    },
  },
}
</script>

<style scoped>
.expansion-panels {
  margin: -24px -24px 0 -24px;
}
</style>
